import { C_BUSINESS_TYPE_ID, O_BUSINESS_TYPE } from "@/src-refactor/modules/shared/model/const/property/business-type.const";
import { C_CONDICTION_PROPERTY } from "@/src-refactor/modules/shared/model/const/property/condition-status.const";
import { C_IMMOVABLE_STATUS } from "@/shared/models/const/properties/immovable-status";

const RENT_BUSINESS_ID = C_BUSINESS_TYPE_ID.RENT;

const normalizeBusinessKey = (businessType: string | number | undefined) => {
  if (businessType === undefined || businessType === null) {
    return undefined;
  }

  if (typeof businessType === "number") {
    return businessType;
  }

  return businessType.trim();
};

const isRentBusiness = (businessType: string | number | undefined) => {
  const key = normalizeBusinessKey(businessType);
  if (key === undefined) return false;

  const business =
    O_BUSINESS_TYPE[key] ||
    (typeof key === "string" ? O_BUSINESS_TYPE[key.toLowerCase()] : undefined);

  return business?.combine?.business === RENT_BUSINESS_ID;
};

const isResaleCondition = (conditionStatus: string) => {
  const normalized = conditionStatus.toLowerCase();
  return (
    normalized === C_CONDICTION_PROPERTY.RESALE.name.toLowerCase() ||
    normalized === C_CONDICTION_PROPERTY.RESALE.label.toLowerCase() ||
    normalized === C_CONDICTION_PROPERTY.RESALE.value.toLowerCase()
  );
};

export const getConditionStatusLabel = (
  conditionStatus: string | null | undefined,
  businessType: string | number | null | undefined
) => {
  if (!conditionStatus) return "";

  if (!isRentBusiness(businessType)) {
    return conditionStatus;
  }

  if (!isResaleCondition(conditionStatus)) {
    return conditionStatus;
  }

  return C_IMMOVABLE_STATUS.used.name;
};
